
import { getDataBase } from '../db';

export default class MedidorAnormalidadDAL {
  Aplicar_ConsumoNormal;
  Aplicar_LecturaPendiente;
  Aplicar_LecturaActual;
  Aplicar_FinDeCiclo;
  Aplicar_ConsumoPromedio;
  Aplicar_MedidorVolcado;
  Aplicar_ConsumoAsignado;
  Aplicar_AjusteLectura;
  Aplicar_InstalacionNueva;

  cTipoConsumo;
  cReglaValidacion;
  constructor() {
    
    this.Aplicar_ConsumoNormal = 0;
    this.Aplicar_LecturaPendiente = 1;
    this.Aplicar_LecturaActual = 2;
    this.Aplicar_FinDeCiclo = 3;
    this.Aplicar_ConsumoPromedio = 4;
    this.Aplicar_MedidorVolcado = 5;
    this.Aplicar_ConsumoAsignado = 6;
    this.Aplicar_AjusteLectura = 7;
    this.Aplicar_InstalacionNueva = 8;

    this.cTipoConsumo = null;
    this.cReglaValidacion = null;
  }

  


  async Get_Regla(MedidorAnormalidad, DataBaseAlias) {
    try {
      const db = await getDataBase();
      const tx = db.transaction('MEDIDORANORMALIDAD', 'readonly');
      const store = tx.objectStore('MEDIDORANORMALIDAD');
      const loData = await store.getAll(Number(MedidorAnormalidad));
      await tx.done;
      return loData;
    } catch (error) {
      console.error('Error en el metodo Get_Regla de dbIndex: ', error);
      return [];

    }
  }



  //RESUELTO
  async Get_TipoReglaAAplicar(MedidorAnormalidad, DataBaseAlias) {
 
    let result = 0;
    if (MedidorAnormalidad <= 0) {
      return result;
    }

    //RESUELTO
    const regla = await this.Get_Regla(MedidorAnormalidad, DataBaseAlias);
    if (regla && regla.length > 0 && regla[0].Regla != null) {
      result = regla[0].Regla;
    }

    return result;
  }


  // const db = await getDataBase();
  // const tx = db.transaction('lecturas_no_subidas', 'readonly');
  // const store = tx.objectStore('lecturas_no_subidas');
  // const laClientes = await store.getAll(tcCliente);
  // await tx.done;
  

  async GetRecDt(MedidorAnormalidad, DataBaseAlias = null) {
   
    try {
      const db = await getDataBase();
      const tx = db.transaction('MEDIDORANORMALIDAD', 'readonly');
      const store = tx.objectStore('MEDIDORANORMALIDAD');
      const loData = await store.getAll(Number(MedidorAnormalidad));
      await tx.done;
      return loData;
    } catch (error) {
      console.error('Error en el metodo GetRecDt de dbIndex: ', error);
      return [];

    }


  }

  async GetReglaValida(tnMedidorAnormalidad, tnTipoConsumo, DataBaseAlias) {

    // public function GetReglaValida($tnMedidorAnormalidad,$tnTipoConsumo, $DataBaseAlias){
    //   $loMedidorAnormalidad = MedidorAnormalidad::on($DataBaseAlias)
    //       ->where('MedidorAnormalidad', '=', $tnMedidorAnormalidad)
    //       ->where('TipoConsumo', '=', $tnTipoConsumo)
    //       ->get();

    //   return $loMedidorAnormalidad;
    // }

    try {
      const db = await getDataBase();
      const tx = db.transaction('MEDIDORANORMALIDAD', 'readonly');
      const store = tx.objectStore('MEDIDORANORMALIDAD');
      const laData = await store.getAll(Number(tnMedidorAnormalidad));


      const laResult = [];
      laData.forEach(loData => {
        if (loData.TipoConsumo == tnTipoConsumo) {
          laResult.push(loData);
        }
      });
      await tx.done;
      return laResult;
    } catch (error) {
      console.error('Error en el metodo Get_Regla de dbIndex: ', error);
      return [];

    }

  }

  async obtenerMensajeAnormalidad(MedidorAnormalidad, DataBaseAlias) {
    //TODO: Implementar la consulta a la base de datos indexDB
    const loMedidorAnormalidad = [];
    return loMedidorAnormalidad
  }


  async EsCasoSinLectura(MedidorAnormalidad, DataBaseAlias) {
    //TODO: Implementar la consulta a la base de datos indexDB
    // const loMedidorAnormalidad = [];
    // return loMedidorAnormalidad

    try {
      const db = await getDataBase();
      const tx = db.transaction('MEDIDORANORMALIDAD', 'readonly');
      const store = tx.objectStore('MEDIDORANORMALIDAD');
      const loData = await store.getAll(Number(MedidorAnormalidad));
      await tx.done;
      return loData;
    } catch (error) {
      console.error('Error en el metodo Get_Regla de dbIndex: ', error);
      return [];

    }
  }

  async getMedidorAnormalidad(MedidorAnormalidad, DataBaseAlias) {
    try {
      const db = await getDataBase();
      const tx = db.transaction('MEDIDORANORMALIDAD', 'readonly');
      const store = tx.objectStore('MEDIDORANORMALIDAD');
      const loData = await store.getAll(Number(MedidorAnormalidad));
      await tx.done;
      return loData;
    } catch (error) {
      console.error('Error en el metodo Get_Regla de dbIndex: ', error);
      return [];
    }
  }

}
